<app-header></app-header>
<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="pt-2 h-100p overflow-y-scroll w-100 advanced-result-main">
        <div class="custom_container advanced-result-layout">
            <div class="search-container">
                <!-- Top bar -->
                <div class="search-header">
                    <div class="header-left">
                        <button class="back-button" (click)="onBackButtonClick()">
                            Back
                        </button>
                    </div>
                    <div class="header-center">
                        <h1 class="search-query">{{searchedName || selectedSearchResult?.searched_name || '-'}}</h1>
                    </div>
                    <div class="header-right">
                        <!-- Search box -->
                        <div class="search-box">
                            <input class="search-input" type="text" placeholder="Search here" [(ngModel)]="searchTerm" (ngModelChange)="onSearchTermChange()" />
                        </div>
                    </div>
                </div>

                <!-- Loader -->
                <div *ngIf="isLoadingResults" class="loading-container text-center my-3">
                    <div class="spinner-border" role="status" aria-label="Loading"></div>
                    <p class="mt-2 text-main-color">Fetching results, please wait...</p>
                </div>

                <!-- Empty / error -->
                <div class="no-results-message" *ngIf="showEmptyState">
                    <ng-container *ngIf="searchErrorMessage; else noFindings">
                        <h2 class="no-results-title">Search failed</h2>
                        <p>{{ searchErrorMessage }}</p>
                    </ng-container>
                    <ng-template #noFindings>
                        <h2 class="no-results-title">No results found</h2>
                        <p>This advanced search did not return any matching records.</p>
                    </ng-template>
                </div>

                <!-- Results -->
                <div class="result-parent-container">
                    <div class="results-container" *ngIf="!isLoadingResults && !showEmptyState">
                        <!-- Results count -->
                        <div class="results-summary w-100 text-center" *ngIf="nameResultsCurrentPage.length > 0">
                            <ng-container *ngIf="searchTerm.trim(); else totalCount">
                                Showing <span class="results-count">{{ nameResults.length }}</span> of {{ nameResultsCurrentPage.length
                }} on this page
                            </ng-container>
                            <ng-template #totalCount>
                                Here we got <span class="results-count">+{{ pagination.total_items }}</span> results
                            </ng-template>
                        </div>

                        <!-- Result Cards -->
                        <div class="result-card" *ngFor="let result of nameResults; let i = index">
                            <div class="card-header">
                                <div class="result-info">
                                    <span class="result-number">Result {{ i + 1 }}</span>
                                </div>
                            </div>

                            <div class="card-body">
                                <div class="data-section">
                                    <div class="data-header">Data</div>
                                    <div class="data-grid">
                                        <div class="data-row" *ngFor="let field of result | keyvalue">
                                            <mat-icon class="field-icon" [attr.data-field]="field.key">{{ getFieldIcon($any(field.key)).icon
                        }}
                                            </mat-icon>
                                            <div class="field-content">
                                                <span class="field-label">{{ formatFieldLabel(field.key) }}</span>
                                                <span class="field-value">{{ field.value || '-' }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Pagination -->
                        <div class="pagination-container mt-3" *ngIf="nameResultsCurrentPage.length > 0">
                            <div class="pagination-info">
                                Showing page {{ pagination.current_page }} of {{ pagination.total_pages }} ({{ pagination.total_items }}
                                total results)
                            </div>
                            <div class="pagination-controls">
                                <app-paginator [totalItems]="pagination.total_items" [itemsPerPage]="pagination.page_size" [currentPage]="pagination.current_page" (pageChange)="onPageChange($event)">
                                </app-paginator>
                            </div>
                        </div>

                        <!-- Notes -->
                        <div class="notes-section" *ngIf="nameResultsCurrentPage.length > 0">
                            <div class="notes-header">
                                Add Notes
                            </div>
                            <div class="notes-content">
                                <textarea class="note-input" maxlength="300" placeholder="Notes" [(ngModel)]="notes"></textarea>
                                <div class="notes-footer">
                                    <span class="character-count">{{notes.length}}/300</span>
                            <button type="button" class="update-button" (click)="onUpdateNotesButtonClick()">
                                        Update Notes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>